import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from './AuthContext';
import App from './App';

// Estilos
import '@aws-amplify/ui-react/styles.css';
import './index.css';

// Configuración de Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_cc3T8fduz',
      userPoolClientId: '5l5agskrqk0sdubmd9j6spq4tu',
    },
  },
  API: {
    REST: {
      dagroApi: {
        endpoint: 'https://9e93brdhge.execute-api.us-east-1.amazonaws.com/Prod',
        region: 'us-east-1',
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);